export const shouldHydrateEditorContent = (currentContent: string, content: string) => {
    const trimmedContent = currentContent.trim();
    return Boolean(content) && (trimmedContent === "" || trimmedContent === "<p></p>");
};
